import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';
// import * as OfflinePluginRuntime from 'offline-plugin/runtime';
import VueOnlinePlugin from 'vue-navigator-online';
import VueAnalytics from 'vue-analytics';
import { onError } from 'apollo-link-error';

import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';
import { split } from 'apollo-link';
import { getMainDefinition } from 'apollo-utilities';
import Cookies from 'js-cookie';

import VueApollo from 'vue-apollo';

import Vuetify, {
  VApp,
  VList,
  VBtn,
  VIcon,
  VCard,
  VAlert,
  VCheckbox,
  VDialog,
  VContainer,
  VSpacer,
  VToolbarItems,
  VToolbarTitle,
  VFadeTransition,
  VSlideYTransition,
  VCardText,
  VCardActions,
  VCardTitle,
  VContent,
  VDivider,
  VSnackbar,
  VMenu,
  VForm,
  VProgressCircular,
  VTextarea,
  VProgressLinear,
  VToolbar,
  VTextField,
  VListTile,
  VSelect,
  VDatePicker,
  VStepper,
  VLayout,
  VFlex,
  VStepperItems,
  VStepperContent,
} from 'vuetify/lib';

import VueImg from 'v-img/dist/v-img';

import CpCarScheme from 'cp-car-scheme';
import LoginPage from 'cp-ui/src/elements/LoginPage';
import request from 'cp-ui/src/api';
import $rules from 'cp-ui/src/rules';

import tabs from './tabs';
import store from './store';

import App from './App';

import CpDatePicker from './components/elements/CpDatePicker';
import CpRadio from './components/elements/CpRadio';
import VCaption from './components/elements/VCaption';
import TabTitle from './components/elements/TabTitle';
import CpRadioConfirmDesc from './components/elements/CpRadioConfirmDesc';
import CpPhoto from './components/elements/CpPhoto';
import CpPdf from './components/elements/CpPdf';
import CpCheckbox from './components/elements/CpCheckbox';
import CpAppointmentSummary from './components/elements/CpAppointmentSummary';

import '../node_modules/vuetify/src/stylus/app.styl';
import './styles/main.scss';

import SearchPage from './pages/SearchPage';
import InspectionPage from './pages/InspectionPage';
import NotFoundPage from './pages/NotFoundPage';

import {
  GET_CAR_FIELDS,
  GET_REMAINING_FIELDS,
  UPSERT_CAR_FIELD,
  UPDATE_TYPE,
  ON_UPDATE_APPOINTMENT,
  ON_UPDATE_CAR,
  GET_USER_DATA,
  PRE_INSPECTION_FLAGS,
} from './queries';

Vue.use(VueOnlinePlugin);
Vue.use(VueApollo);
// OfflinePluginRuntime.install();

Vue.use(Router);
Vue.use(Meta);

Vue.use(Vuetify, {
  components: {
    VApp,
    VBtn,
    VIcon,
    VList,
    VCheckbox,
    VDialog,
    VContainer,
    VSpacer,
    VToolbarItems,
    VToolbarTitle,
    VFadeTransition,
    VSlideYTransition,
    VCardText,
    VCardActions,
    VCardTitle,
    VContent,
    VDivider,
    VSnackbar,
    VCard,
    VAlert,
    VMenu,
    VForm,
    VProgressCircular,
    VTextarea,
    VProgressLinear,
    VToolbar,
    VTextField,
    VListTile,
    VSelect,
    VDatePicker,
    VStepper,
    VLayout,
    VFlex,
    VStepperItems,
    VStepperContent,
  },
  theme: {
    primary: '#bf0000',
    accent: '#00E676',
    info: '#3949AB',
  },
});
Vue.use(VueImg);

Vue.use(CpCarScheme);

if (!Vue.prototype.$rules) {
  Object.defineProperties(Vue.prototype, {
    $rules,
  });
}

Vue.config.productionTip = false;

const noop = () => { };

Vue.mixin({
  components: {
    CpDatePicker,
    VCaption,
    CpRadio,
    CpPhoto,
    CpPdf,
    TabTitle,
    CpRadioConfirmDesc,
    CpCheckbox,
    CpAppointmentSummary,
  },
  computed: {
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    isMobile() {
      return this.breakpoint.sm || this.breakpoint.xs;
    },
    headline() {
      return this.isMobile ? 'headline' : 'display-1';
    },
  },
  methods: {
    request,
    ruleExists(v, items, itemValue = 'value') {
      return !!items.find(i => i[itemValue] === v) || '必須項目です。';
    },
    async updateAppointment(params) {
      const id = parseInt(this.$route.params.id, 10);
      let refetchQueries = () => [{
        query: PRE_INSPECTION_FLAGS,
        variables: {
          id,
        },
      }];

      if (params.refetchQueries) refetchQueries = [...refetchQueries, params.refetchQueries];

      this.update({
        ...params,
        id,
        type: 'Appointment',
        refetchQueries,
        onUpdate: (cache) => {
          cache.writeQuery({
            query: ON_UPDATE_APPOINTMENT(params),
            data: {
              appointment: {
                id,
                [params.field]: params.value,
                __typename: 'Appointment',
              },
            },
          });
        },
      });
    },
    async updateCar(params) {
      let refetchQueries = [
        {
          query: GET_REMAINING_FIELDS,
          variables: {
            appointmentId: parseInt(this.appointment.id, 10),
            tabs: ['Owner', 'Basic', 'Equipment', 'SalesPoints', 'Photos',
              'Damages', 'Attention', 'Repairs', 'ConfirmForSelfIns', 'Evaluation'],
          },
        },
      ];
      if (params.refetchQueries) refetchQueries = [...refetchQueries, params.refetchQueries];

      this.update({
        ...params,
        id: this.appointment.car.id,
        type: 'Car',
        value: params.value ? params.value.toString() : null,
        onUpdate: (cache) => {
          cache.writeQuery({
            query: ON_UPDATE_CAR(params),
            data: {
              car: {
                id: this.appointment.car.id,
                [params.field]: params.value,
                __typename: 'Car',
              },
            },
          });
        },
        refetchQueries,
      });
    },
    async updateField(variables) {
      if (!variables.value) return;

      const refetchQueries = () => [{
        query: GET_CAR_FIELDS,
        variables: {
          carId: parseInt(this.appointment.car.id, 10),
        },
      }, {
        query: GET_REMAINING_FIELDS,
        variables: {
          appointmentId: parseInt(this.appointment.id, 10),
          tabs: ['Owner', 'Basic', 'Equipment', 'SalesPoints', 'Photos',
            'Damages', 'Attention', 'Repairs', 'ConfirmForSelfIns', 'Evaluation'],
        },
      },
      ];

      this.$apollo.mutate({
        mutation: UPSERT_CAR_FIELD,
        variables: {
          ...variables,
          carId: this.appointment.car.id,
        },
        refetchQueries,
      });
    },
    async update({ type, refetchQueries, onUpdate = noop, ...variables }) {
      const nullAbleFields = ['inspectionDate', 'sts'];
      if (!variables.value && !nullAbleFields.includes(variables.field)) return;

      this.$apollo.mutate({
        mutation: UPDATE_TYPE(type),
        variables,
        refetchQueries,
        onUpdate,
      });
    },
    async refreshRemainingFields() {
      this.$apollo.query({
        query: GET_REMAINING_FIELDS,
        fetchPolicy: 'network-only',
        variables: {
          appointmentId: parseInt(this.appointment.id, 10),
          tabs: ['Owner', 'Basic', 'Equipment', 'SalesPoints', 'Photos',
            'Damages', 'Attention', 'Repairs', 'ConfirmForSelfIns', 'Evaluation'],
        },
      });
    },
    scrollTo(element, timeout) {
      const block = element || document.body;

      let blockY = block.getBoundingClientRect().top;
      const timeDelta = 10;
      const scrollsCnt = (timeout || 500) / timeDelta;
      const scrollStep = (blockY) / scrollsCnt;

      blockY += window.scrollY;

      let oldScrollY = -1;

      const interval = setInterval(() => {
        if (Math.abs(blockY - window.scrollY) <= Math.abs(scrollStep)
          || oldScrollY === window.scrollY) {
          window.scrollTo(window.scrollX, blockY);
          clearInterval(interval);
          return;
        }
        oldScrollY = window.scrollY;
        window.scrollTo(window.scrollX, window.scrollY + scrollStep);
      }, timeDelta);
    },
  },
});

const router = new Router({
  mode: 'history',
  base: process.env.BASE_PATH || '/',
  routes: [
    {
      path: '',
      name: 'login',
      component: LoginPage,
      props: {
        onAuth: noop,
      },
    },
    {
      path: '/search',
      component: SearchPage,
      props: route => route.query,
    },
    {
      path: '/inspection/:id',
      component: InspectionPage,
      children: tabs,
    },
    {
      path: '*',
      name: '404',
      component: NotFoundPage,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash === '#top') {
      return { x: 0, y: 0 };
    }
    return savedPosition;
  },
});

Vue.use(VueAnalytics, {
  id: 'UA-72407523-9',
  router,
});

const httpLink = new HttpLink({
  uri: process.env.API_PATH,
  credentials: 'same-origin',
});

const authLink = setContext((_, { headers }) => {
  const token = Cookies.get('apollo-token', { path: process.env.BASE_PATH.replace(/\/$/, '') });
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const hasTheseErrors = (graphQLErrors, arr) => graphQLErrors.map(
  e => (e.extensions ? e.extensions.name : null)).flat().filter(e => arr.includes(e)).length > 0;

const errorLink = onError((data) => {
  const { graphQLErrors } = data;

  if (hasTheseErrors(graphQLErrors, ['GradeMatchError'])) return;
  store.commit('setError', {
    message: graphQLErrors[0].message || 'エラーが発生しました',
  });

  if (graphQLErrors && graphQLErrors.find(e => e.message === 'アクセスができません')) {
    Cookies.remove('apollo-token', { path: process.env.BASE_PATH.replace(/\/$/, '') });
    router.push('/');
    return;
  }

  if (graphQLErrors[0].path.find(e => e === 'gradesByQR')) return;
  router.push('/search');
});

const link = split(
  // split based on operation type
  ({ query }) => {
    const { kind, operation } = getMainDefinition(query);
    return kind === 'OperationDefinition' &&
      operation === 'subscription';
  },
  httpLink,
  // wsLink,
  httpLink,
);

//  the apollo client
const apolloClient = new ApolloClient({
  link: errorLink.concat(authLink).concat(link),
  cache: new InMemoryCache(),
  connectToDevTools: process.env.NODE_ENV !== 'production',
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions: {
    $loadingKey: 'loading',
  },
});

const allowedRoles = ['inspectors'];
const hasAllowedRoles = user => user.roles && allowedRoles.some(role => user.roles.includes(role));

router.options.routes[0].props.onAuth = (accessToken, getPasswordLife) => {
  if (!accessToken) return;
  apolloProvider.defaultClient.query({
    query: GET_USER_DATA,
    fetchPolicy: 'network-only',
  }).then(({ data: { user } }) => {
    if (!hasAllowedRoles(user)) {
      store.commit('setError', { message: 'ログインできません' });
      Cookies.remove('apollo-token', { path: process.env.BASE_PATH.replace(/\/$/, '') });
    } else {
      if (getPasswordLife && getPasswordLife() <= 5) return;

      router.push('/search');
    }
  });
};

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  apolloProvider,
  store,
  router,
});



// WEBPACK FOOTER //
// ./src/main.js